"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredCornerVector4 = exports.StoredEdgeVector4 = exports.StoredAutoVector3 = exports.StoredSchematicPosition2 = exports.StoredAutoVectors = exports.Matrix4Array = void 0;
const zod_1 = require("zod");
/**
 * Note: we use zod / zod.infer here because we use .parse in mat4.ts to ensure the shape of a given
 * array matches the shape of Matrix4Array. We'd generally avoid using zod for primitive types
 * otherwise (see comments above eg IVector2 below)
 */
exports.Matrix4Array = zod_1.z.tuple([
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
    zod_1.z.number(),
]);
exports.StoredAutoVectors = zod_1.z.object({
    autoX: zod_1.z.boolean().optional(),
    autoY: zod_1.z.boolean().optional(),
    /**
     * autoZ does not appear used anywhere
     * @deprecated
     */
    autoZ: zod_1.z.boolean().optional(),
});
exports.StoredSchematicPosition2 = zod_1.z.object({
    ...exports.StoredAutoVectors.shape,
    /**
     * X coordinate.
     */
    x: zod_1.z.number(),
    /**
     * Y coordinate.
     */
    y: zod_1.z.number(),
    /**
     * Rotation of the object that is at this position, in radians.
     * @privateRemarks This is confusing, vectors don't have rotation. If removed, also remove it from schema {@link StoredAutoVectorsSchema}
     */
    orientation: zod_1.z.optional(zod_1.z.number()),
    /**
     * True if the object should be mirrored (invert y and x).
     * @privateRemarks Why is this in here?  Appears to be only used for kicad export. Consider removing. If removed, also remove it from schema {@link StoredAutoVectorsSchema}
     */
    mirror: zod_1.z.optional(zod_1.z.boolean()),
    /**
     * Indicates if the object should be flipped about its x axis.
     * @privateRemarks consider renaming to flipX
     */
    flip: zod_1.z.optional(zod_1.z.boolean()),
    /**
     * If this is true, then the coordinates are in scene coordinates.
     * @deprecated This is never assigned a `false` value, and looks to be unused except perhaps for legacy parts. Do we have legacy parts that use it?
     * @privateRemarks This should probably just be another type altogether.
     */
    scene_cursor_position: zod_1.z.optional(zod_1.z.boolean()),
});
exports.StoredAutoVector3 = zod_1.z.object({
    ...exports.StoredAutoVectors.shape,
    x: zod_1.z.number(),
    y: zod_1.z.number(),
    z: zod_1.z.number(),
    // I don't think `orientation` or `flip` are used, but they're here for historical reasons
    /** @deprecated */
    preorientation: zod_1.z.optional(zod_1.z.number()),
    /** @deprecated */
    flip: zod_1.z.optional(zod_1.z.boolean()),
});
/**
 * Represent values that correspond to edges of a rectangle
 */
exports.StoredEdgeVector4 = zod_1.z.object({
    left: zod_1.z.number(),
    right: zod_1.z.number(),
    top: zod_1.z.number(),
    bottom: zod_1.z.number(),
});
/**
 * Represent values that correspond to corners of a rectangle.
 */
exports.StoredCornerVector4 = zod_1.z.object({
    topLeft: zod_1.z.number(),
    topRight: zod_1.z.number(),
    bottomLeft: zod_1.z.number(),
    bottomRight: zod_1.z.number(),
});
//# sourceMappingURL=vector.js.map